import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import kit from '../../images/wmgr_presentation_assets/wmgr_concept_elements/wmgr_kit.png';
import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class HowItWorks extends Component {
  render() {
    return (
        <div>
       <div className="container mit">
        <div className="container_message" >
          
          <div className="content_text_title">Leading Research Collaboration</div>
          <div className="content_text">
            <img className="content_image" src={kit}/>
            WMGR is a wellness innovation company bringing together the best technologies and global data to improve quality of life and longevity.
          </div> 
          <Button className="button_learn_more" intent="primary" icon="chevron-right">Learn More</Button>
           </div>
        
    </div>
    <div className="features">
    <div className="container_space" >
      <div className="feature_image ipad_data"/>
      <div className="content_text">
      <div className="content_text_title">Data Analytics</div>
      We understand the power of data, and therefore work to understand our clients and global health and wellness topics from a new level synthesizing both global and personalized health data for research and customer benefit.
      </div>
    </div>
    <div className="container_space" >
      <div className="feature_image ipad_project"/>
      <div className="content_text">
      <div className="content_text_title">Portable Collaboration</div>
      Access to your information when you need it is important to us.  We develop and provide a variety of secure access to your wellness information and connect global experts through our technology ecosystem.
      </div>
      </div>
      </div>
      <div className="banner_callout">
          <div className="banner_callout_text">
      A unique healthcare ecosystem, integrating the latest technology from all fields to provide a new platform of personalized health and wellbeing and leveraging global intelligence.
      </div>
      </div>
      <div className="banner flow"/>
</div>
    );
  }
}

export default HowItWorks;